import {
  HelpCenterSection,
  SectionId,
} from '@wix/wix-help-widget-common/homepage';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SEARCH_LIMIT, solutionsSlice } from '../../common/reducers/solutions';
import { selectHomepageContent } from '../../common/selectors/homepage';
import { loadSolutions } from '../../common/thunks/solutions.thunk';

let currentPage = 0;

export const useFetchSolutions = (query: string) => {
  const dispatch = useDispatch();
  const { data: homepageContent } = useSelector(selectHomepageContent);

  const excludedCategories = useMemo(() => {
    const helpcenterSection = homepageContent?.sections.find(
      (section) => section.sectionId === SectionId.HelpCenter,
    ) as HelpCenterSection;
    if (helpcenterSection) {
      return helpcenterSection.excludedCategoriesIds || [];
    }
    return [];
  }, [homepageContent]);

  const fetchSolutions = useCallback(async () => {
    dispatch(
      loadSolutions({
        query,
        limit: SEARCH_LIMIT,
        offset: SEARCH_LIMIT * currentPage++,
        ...(excludedCategories ? { excludedCategories } : {}),
      }),
    );
  }, [dispatch, query]);

  const clearSolutions = useCallback(() => {
    currentPage = 0;
    dispatch(solutionsSlice.actions.resetSolutions());
  }, [dispatch]);

  useEffect(() => {
    clearSolutions();
    if (query.length < 2) {
      return;
    }
    void fetchSolutions();
  }, [query]);

  return {
    fetchSolutions,
  };
};
